@if (totalPages() > 1 || total() > 0) {
  <nav class="ks-pagination" aria-label="Paginacion de resultados">
    <p class="ks-pagination__range" aria-live="polite">
      @if (total() === 0) {
        Sin resultados
      } @else {
        Mostrando <strong>{{ rangeFrom() }}</strong>&ndash;<strong>{{ rangeTo() }}</strong>
        de <strong>{{ total() }}</strong>
      }
    </p>

    @if (totalPages() > 1) {
      <ul class="ks-pagination__list">
        <li>
          <button
            type="button"
            class="ks-pagination__btn"
            [disabled]="isFirst()"
            aria-label="Pagina anterior"
            (click)="previous()">
            <i class="bi bi-chevron-left" aria-hidden="true"></i>
          </button>
        </li>

        @for (item of pages(); track $index) {
          <li>
            @if (item === null) {
              <span class="ks-pagination__ellipsis" aria-hidden="true">&hellip;</span>
            } @else {
              <button
                type="button"
                class="ks-pagination__btn"
                [class.is-active]="item === page()"
                [attr.aria-current]="item === page() ? 'page' : null"
                [attr.aria-label]="'Ir a la pagina ' + item"
                (click)="goTo(item)">
                {{ item }}
              </button>
            }
          </li>
        }

        <li>
          <button
            type="button"
            class="ks-pagination__btn"
            [disabled]="isLast()"
            aria-label="Pagina siguiente"
            (click)="next()">
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
    }
  </nav>
}
